export default class paths {
  static login = "/login";
  static home = "/";
  static user = "/user";
}
